import { useState } from "react";
import { useFlags } from "launchdarkly-react-client-sdk";

import { memberService } from "../services";

import { formatName } from "../utils/documentUtils";
import { ModalState, StateType } from "./types";

export function useUpdateForm(state: StateType) {
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdatingData, setIsUpdatingData] = useState(true);
  const [isError, setIsError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const { apiDomain } = useFlags();

  const onFormSubmit = async (modalState: ModalState) => {
    setIsLoading(true);
    setIsUpdatingData(false);

    function phoneValidation(phone: string) {
      const phoneValue = phone.replace(/[^^0-9 ]/g, "");
      const phoneAreaCode = phoneValue.substring(0, 2);
      const phoneNumber = phoneValue.substring(2).trimStart();
      return {
        phoneAreaCode,
        phoneNumber,
      };
    }
    try {
      const member = {
        socialReason: modalState.socialReason,
        fantasyName: modalState.fantasyName,
        occupation: modalState.occupation,
        firstName: formatName(modalState.adminName, "first"),
        lastName: formatName(modalState.adminName, "last"),
        email: modalState.email,
        balanceRedeemablePoints: "",
        balanceQualifyingPoints: "",
        customerCategory: state.member.tier,
        codeReserve: "",
        numberOfEmployees: modalState.numberOfEmployees,
        mainActivity: modalState.mainActivity,
        annualBudgetforTravel: modalState.annualBudgetforTravel,
        documentNumber: modalState.DOcumentNumber,
        organizationName: `VB - VRG Linhas Aereas S.A.`,
        address: {
          streetAddress: modalState.streetAddress,
          streetAddressNumber: modalState.streetAddressNumber,
          city: modalState.city,
          state: modalState.state,
          complement: modalState.complement,
          zipCode: modalState.zipCode.replace(/[^^0-9 ]/g, ""),
          country: modalState.country,
        },
        celPhone: {
          // Telefone 1
          DDINumber1: "",
          DDDNumber1: phoneValidation(modalState.celPhoneNumber1).phoneAreaCode,
          Number1: phoneValidation(modalState.celPhoneNumber1).phoneNumber,
        },
        homePhone: {
          // Telefone 2
          DDINumber1: "",
          DDDNumber1: phoneValidation(modalState.homePhoneNumber1).phoneAreaCode,
          Number1: phoneValidation(modalState.homePhoneNumber1).phoneNumber,
        },
      };
      const response = await memberService(apiDomain).put(member);

      if (response.data !== "solicitação de alteração cadastral está sendo analisada pela equipe Smiles") {
        throw new Error();
      }
      setIsSuccess(true);
    } catch (err) {
      setIsError(true);
      setIsSuccess(false);
    }

    setIsLoading(false);
  };

  const tryAgain = () => {
    setIsError(false);
    setIsLoading(false);
    setIsUpdatingData(true);
  };

  return {
    isLoading,
    isUpdatingData,
    isError,
    isSuccess,
    onFormSubmit,
    tryAgain,
  };
}
